import { Box, Flex, Text } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
import CtaButton from './CtaButton';
import { ReviewData } from './Reviews';

// Create motion components
const MotionFlex = motion(Flex);

// The review highlighted on the home page
const featuredReview = ReviewData[1];

/**
 * Home page teaser for the Reviews page: one featured review and a CTA
 */
export default function ReviewsPreview() {
	return (
		<Flex
			width={"100%"}
			backgroundColor={"blue.200"}
			paddingY={{ base: 12, md: 20 }}
		>
			<Flex
				width={{ base: "90%", lg: "80%" }}
				maxWidth={"1200px"}
				margin={"auto"}
				// Side by side only on laptops and up; phones and iPads stack the title above the review
				flexDirection={{ base: "column", lg: "row" }}
				alignItems={"flex-start"}
				gap={{ base: 8, lg: 16 }}
			>
				{/* Review Title */}
				<MotionFlex
					// Own stacking context so the quote mark can sit behind the text
					position={"relative"}
					zIndex={0}
					flex={1}
					paddingTop={2}
					initial={{ opacity: 0, x: -50 }}
					whileInView={{ opacity: 1, x: 0 }}
					viewport={{ once: true, amount: 0.3 }}
					transition={{ duration: 0.7, ease: "easeOut" }}
				>
					{/* Faded quote mark behind the text */}
					<Box
						position={"absolute"}
						// Pulled up out of the column so it doesn't add height to the title
						top={{ base: -8, md: -12 }}
						left={{ base: -2, md: -6 }}
						zIndex={-1}
						opacity={0.15}
						pointerEvents={"none"}
						aria-hidden
					>
						<Quote size={140} color={"#D0A144"} fill={"#D0A144"} />
					</Box>

					<Text
						fontFamily={"Martel"}
						fontWeight={"800"}
						fontSize={{ base: "6xl", md: "7xl", lg: "8xl" }}
						lineHeight={1.2}
						color={"white.500"}
					>
						{featuredReview.title}
					</Text>
				</MotionFlex>

				{/* Full Review + CTA */}
				<MotionFlex
					flex={1}
					flexDirection={"column"}
					alignItems={"flex-start"}
					gap={5}
					initial={{ opacity: 0, y: 30 }}
					whileInView={{ opacity: 1, y: 0 }}
					viewport={{ once: true, amount: 0.3 }}
					transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
				>
					<Flex gap={2}>
						{[...Array(5)].map((_, index) => (
							<Star key={index} color='gold' fill='gold' />
						))}
					</Flex>

					<Text
						fontFamily={"Montserrat"}
						fontWeight={"500"}
						fontSize={{ base: "md", md: "lg" }}
						lineHeight={1.7}
						color={"white.500"}
					>
						{featuredReview.description}
					</Text>

					<Text
						fontFamily={"Montserrat"}
						fontWeight={"600"}
						color={"yellow.100"}
					>
						— {featuredReview.name}
					</Text>

					<CtaButton to={"/reviews"}>
						Read More Reviews
					</CtaButton>
				</MotionFlex>
			</Flex>
		</Flex>
	);
}
